type LockyOrderData = {
    readonly _type: "LOCKY_ORDER_DATA";
    readonly bookingId: string;
    readonly code: string;
};

const lockyOrderDataFactory = (params: {
    bookingId: string;
    code: string;
}): LockyOrderData => {
    return {
        _type: "LOCKY_ORDER_DATA",
        ...params,
    };
};

export { lockyOrderDataFactory };
export type { LockyOrderData };
